import styled from 'styled-components'

export const SidebarContainer = styled.div`
  .drawer {
    background: #ffffff !important;
    border-top-right-radius: 1rem !important;
    width: 40% !important;
    padding: 0 1rem !important;
  }

  .header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    margin-top: 30px;
  }

  .title {
    font-size: 18px !important;
    font-weight: bold;
  }

  .group {
    color: #4183c4;
    cursor: grab !important;
    margin: 15px;
  }

  .group-name {
    font-size: 17px !important;
    margin-bottom: 10px;
  }

  .question-name {
    font-size: 15px !important;
    margin-bottom: 5px;
    border: 1px solid #e5e7eb;
    padding: 7px;
    border-radius: 5px;    
    color: #4183c4;
    cursor: grab !important;
    margin-left: 10px;
  }

  .questions {
    color: #4183c4;
    cursor: grab !important;
    margin-left: 10px;
  }
`;